import React from "react";
import collapse from '../../../images/collapse_gray.svg'
import styles from './layer-element/layer-element.module.css'
import LayerElement, { layerType } from './layer-element/layer-element'
import { useDispatch, useSelector } from "react-redux";
import { changeCollaps } from "../../../services/reducers/terrain";

export default function TerrainControl() {
    const terrain = useSelector(state => state.terrain);
    const dispatch = useDispatch();

    return (
        <div className={styles.layerElementContainer}>
            <div className={styles.layerElement}>
                <img
                    className={terrain.collapsed === true ? styles.groupElementImgCollapsed : styles.groupElementImg}
                    src={collapse}
                    onClick={() => dispatch(changeCollaps())}
                ></img>
                <div className={styles.labelContainer}>
                    <div className={styles.label}>{terrain.label}</div>
                </div>
            </div>

            <div className={`${styles.elementsContainer} ${terrain.collapsed ? styles.collapsed : ''}`}>
                {terrain.elements.map((el) => (
                    <LayerElement key={el.id} layer={el}/>
                ))}
            </div>
        </div>
    )
}
